import { Controller } from 'react-hook-form'

import { Select, SelectProps, Option } from './Select'

interface Props extends Omit<SelectProps, 'value' | 'onChange'> {
  control: any
  onChange?: (opt: Option) => void
}

export const SelectControlled = ({ control, onChange, ...selectProps }: Props) => {
  return (
    <Controller
      control={control}
      name={selectProps.name}
      render={({ field: { onChange: RHFonChange, value } }) => (
        <Select
          {...selectProps}
          onChange={(e) => {
            RHFonChange(e)
            if (onChange) onChange(e)
          }}
          value={value}
        />
      )}
    />
  )
}
